// noinspection UnnecessaryLocalVariableJS
import React from "react";

import {
  useMutation as defaultUseMutation,
  useQuery as defaultUseQuery,
} from "@apollo/react-hooks";

import { ApolloInjection } from "../types";

const ApolloInjectionContext = React.createContext<Required<ApolloInjection>>({
  useQuery: defaultUseQuery,
  useMutation: defaultUseMutation,
});

export const useApolloInjection = () =>
  React.useContext(ApolloInjectionContext);

type Props = { children: React.ReactNode } & ApolloInjection;

export const ApolloInjectionProvider = (props: Props) => {
  const value = React.useMemo(
    () => ({
      useQuery: props.useQuery ?? defaultUseQuery,
      useMutation: props.useMutation ?? defaultUseMutation,
    }),
    [props.useMutation, props.useQuery]
  );

  return (
    <ApolloInjectionContext.Provider value={value}>
      {props.children}
    </ApolloInjectionContext.Provider>
  );
};

export const withApolloInjectionProvider = <P extends object>(
  Component: React.ComponentType<P>
) => {
  const ComponentWithApolloInjection = ({
    useQuery,
    useMutation,
    ...otherProps
  }: P & ApolloInjection) => {
    return (
      <ApolloInjectionProvider useMutation={useMutation} useQuery={useQuery}>
        <Component {...(otherProps as P)} />
      </ApolloInjectionProvider>
    );
  };

  return ComponentWithApolloInjection;
};
